import type { ClassValue } from 'clsx';
import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Strips zero-width characters. In dev, Tolgee's in-context tools append them to
 * every `ct()` result, so they leak into anything built from translated text.
 */
export function stripInvisible(text: string) {
  return text.replace(/[​-‍⁠﻿]/g, '');
}

/**
 * Makes a translated string safe as a download filename — the invisible Tolgee
 * markers would otherwise become a run of `_` in the saved name.
 */
export function toFilename(name: string) {
  return stripInvisible(name)
    .replace(/[\\/:*?"<>|\u0000-\u001F]+/g, ' ')
    .replace(/\s+/g, ' ')
    .replace(/ (?=\.[^.]+$)/, '')
    .trim();
}
